
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./AssistantDock": () => {
return Promise.all(/*  | __federation_expose_AssistantDock */ [__webpack_require__.e("949"), __webpack_require__.e("787"), __webpack_require__.e("261"), __webpack_require__.e("450"), __webpack_require__.e("542")]).then(() => (() => (__webpack_require__(6281))));
},
"./VoiceCommandSettings": () => {
return Promise.all(/*  | __federation_expose_VoiceCommandSettings */ [__webpack_require__.e("787"), __webpack_require__.e("535")]).then(() => (() => (__webpack_require__(868))));
},
"./VoiceController": () => {
return Promise.all(/*  | __federation_expose_VoiceController */ [__webpack_require__.e("261"), __webpack_require__.e("483")]).then(() => (() => (__webpack_require__(9046))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };